import React from 'react';

const Footer: React.FC = () => (
  <footer style={{ background: '#fff', borderTop: '1px solid #eee', padding: '3rem 0' }}>
    <div style={{
      maxWidth: 1300,
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      padding: '0 2rem',
      '@media (max-width: 768px)': {
        padding: '0 1rem',
        gap: '1rem',
      }
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '1.5rem',
        '@media (max-width: 768px)': {
          flexDirection: 'column',
          gap: '0.5rem',
          alignItems: 'center',
        }
      }}>
        <img src="/silomedai-assets/images/silo-logo-default.png" alt="SILO Logo" style={{ height: '40px', marginRight: '0.75rem', borderRadius: '3px' }} />
        <span style={{ color: '#888', fontSize: '1rem', fontWeight: 400, '@media (max-width: 768px)': { fontSize: '0.95rem', textAlign: 'center' } }}>
          Simulated Intelligence Learning Opportunities
        </span>
      </div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '1rem',
        '@media (max-width: 768px)': {
          flexDirection: 'column',
          gap: '0.5rem',
          alignItems: 'center',
          marginTop: '0.5rem',
        }
      }}>
        <div style={{ color: '#888', fontSize: '1rem', '@media (max-width: 768px)': { fontSize: '0.95rem', textAlign: 'center' } }}>
          © 2025 SILO. All rights reserved.
        </div>
        <div style={{ display: 'flex', gap: '1.5rem', '@media (max-width: 768px)': { gap: '1rem' } }}>
          <a href="/#" style={{ color: '#666', textDecoration: 'none', fontWeight: 500, fontSize: '1rem', '@media (max-width: 768px)': { fontSize: '0.95rem' } }}>Privacy Policy</a>
          <a href="/#" style={{ color: '#666', textDecoration: 'none', fontWeight: 500, fontSize: '1rem', '@media (max-width: 768px)': { fontSize: '0.95rem' } }}>Terms of Service</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer; 